import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

/** Radix onOpenChange(false): allow on web; on native only via NativeSheetDismissProvider. */
export function bindNativeAwareOpenChange(
  onOpenChange?: (open: boolean) => void,
): (open: boolean) => void {
  return (next: boolean) => {
    if (next) {
      onOpenChange?.(true);
      return;
    }
    if (!isNativeCapacitorApp()) {
      onOpenChange?.(false);
    }
  };
}
